module.exports = __webpack_public_path__ + "static/img/21-1.0e274c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/21-1.jpg
// module id = 1TGm
// module chunks = 0